import '../../styles/blocks/portfolio-listing.scss';

(function () {
function readBlockConfig(root) {
  const boot = root.querySelector('script.portfolio-listing__boot[type="application/json"]');
  if (boot && boot.textContent) {
    try {
      return JSON.parse(boot.textContent.trim());
    } catch {
      return null;
    }
  }
  return null;
}

async function fetchListing(restUrl, nonce, body) {
  const res = await fetch(restUrl, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-WP-Nonce': nonce,
    },
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg =
      data.message ||
      (data.code ? String(data.code) : null) ||
      `Request failed: ${res.status}`;
    throw new Error(msg);
  }
  return data;
}

function setLoading(root, loading) {
  root.classList.toggle('portfolio-listing--loading', loading);
}

function renderPagination(el, maxPages, currentPage, onPage) {
  if (!el) {
    return;
  }
  if (maxPages <= 1) {
    el.innerHTML = '';
    return;
  }

  const frag = document.createDocumentFragment();
  for (let p = 1; p <= maxPages; p += 1) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'portfolio-listing__page-btn' + (p === currentPage ? ' is-active' : '');
    btn.textContent = String(p);
    btn.addEventListener('click', () => onPage(p));
    frag.appendChild(btn);
  }
  el.innerHTML = '';
  el.appendChild(frag);
}

function filterIdFromButton(btn) {
  const v = btn.getAttribute('data-pl-filter');
  if (v === null || v === '') {
    return 0;
  }
  const n = parseInt(v, 10);
  return Number.isNaN(n) ? 0 : n;
}

function initBlock(root) {
  const global = window.pvtlPortfolioListing;
  if (!global || !global.restUrl || !global.nonce) {
    return;
  }

  const config = readBlockConfig(root);
  const signature = root.getAttribute('data-signature') || '';
  if (!config || !signature) {
    return;
  }

  const resultsEl = root.querySelector('[data-pl-results]');
  const filterWrap = root.querySelector('[data-pl-filters]');
  const pagesEl = root.querySelector('[data-pl-pagination]');
  const loadWrap = root.querySelector('[data-pl-load-wrap]');
  const loadBtn = root.querySelector('[data-pl-load-more]');
  const type = root.dataset.paginationType || 'numbered';
  const paginationOn = root.dataset.enablePagination === '1';

  let activeCategory = 0;
  let currentPage = 1;
  let maxPages = parseInt(root.dataset.maxPages || '1', 10) || 1;
  let loading = false;
  let hasMore = paginationOn && type === 'infinite' && currentPage < maxPages;

  function updateLoadMoreUi() {
    if (!loadWrap || !loadBtn) {
      return;
    }
    const show = paginationOn && type === 'infinite' && hasMore;
    loadWrap.hidden = !show;
    loadBtn.disabled = loading || !hasMore;
    if (!hasMore) {
      loadBtn.setAttribute('aria-busy', 'false');
    }
  }

  async function loadPage(page, replace = true) {
    if (loading) {
      return;
    }
    loading = true;
    setLoading(root, true);
    if (loadBtn) {
      loadBtn.setAttribute('aria-busy', 'true');
    }
    try {
      const data = await fetchListing(global.restUrl, global.nonce, {
        signature,
        config,
        category_id: activeCategory,
        page,
      });
      if (!data.success || typeof data.html !== 'string') {
        throw new Error('Invalid response');
      }
      if (replace && resultsEl) {
        resultsEl.innerHTML = data.html;
      } else if (resultsEl && !replace) {
        const grid = resultsEl.querySelector('.portfolio-listing__grid');
        if (grid) {
          const tmp = document.createElement('div');
          tmp.innerHTML = data.html;
          const newGrid = tmp.querySelector('.portfolio-listing__grid');
          if (newGrid) {
            grid.append(...newGrid.children);
          }
        } else {
          resultsEl.insertAdjacentHTML('beforeend', data.html);
        }
      }
      currentPage = data.page || page;
      maxPages = data.max_pages || 1;
      root.dataset.maxPages = String(maxPages);
      hasMore = !!data.has_more;

      if (paginationOn && type === 'numbered' && pagesEl) {
        renderPagination(pagesEl, maxPages, currentPage, (p) => {
          loadPage(p, true);
        });
      }

      updateLoadMoreUi();
    } catch (e) {
      if (resultsEl && replace) {
        resultsEl.innerHTML =
          '<p class="portfolio-listing__error">' +
          (e.message || 'Could not load portfolios.') +
          '</p>';
      }
    } finally {
      loading = false;
      setLoading(root, false);
      if (loadBtn) {
        loadBtn.setAttribute('aria-busy', 'false');
      }
      updateLoadMoreUi();
    }
  }

  root.addEventListener('click', (ev) => {
    const filterBtn = ev.target.closest('[data-pl-filter]');
    if (filterBtn && filterWrap && filterWrap.contains(filterBtn)) {
      ev.preventDefault();
      activeCategory = filterIdFromButton(filterBtn);
      filterWrap.querySelectorAll('[data-pl-filter]').forEach((b) => b.classList.remove('is-active'));
      filterBtn.classList.add('is-active');
      currentPage = 1;
      loadPage(1, true);
      return;
    }

    const moreBtn = ev.target.closest('[data-pl-load-more]');
    if (moreBtn && root.contains(moreBtn)) {
      ev.preventDefault();
      if (!hasMore || loading) {
        return;
      }
      loadPage(currentPage + 1, false);
    }
  });

  if (paginationOn && type === 'numbered' && pagesEl) {
    renderPagination(pagesEl, maxPages, currentPage, (p) => {
      loadPage(p, true);
    });
  }

  hasMore = paginationOn && type === 'infinite' && currentPage < maxPages;
  updateLoadMoreUi();
}

function boot() {
  document.querySelectorAll('[data-pvtl-pl]').forEach(initBlock);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
})();
